module.exports = __webpack_public_path__ + "img/campaignpilot-campaign-event.ac385bcd.png";